import { createContext } from 'react';
import { DEFAULT_DEBUG_BOUNDARY_VISIBLE } from '../../internal/constants';
export default /*#__PURE__*/ createContext(DEFAULT_DEBUG_BOUNDARY_VISIBLE);

//# sourceMappingURL=DebugBoundaryVisibleContext.js.map